import api from './AxiosInstance';

export class ExerciceDocService {
  
  getComptaExercices = async () => {
    try {
      const response = await api.get(`/Compta/Exercices`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  getFactureExercicesDoc = async () => {
    try {
      const response = await api.get(`/Facture/Exercices`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
     
         getAllExercicesDoc = async () => {
            try {
              const response = await api.get(`/Document/Exercices`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
  
          getAllExLettre = async () => {
            try {
              const response = await api.get(`/LettreCheque/Exercices`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
}